<script setup lang="ts">
import BaseHorizontalList from '@/components/base/BaseHorizontalList.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { FilterOption } from '@/types/filter.types'
import ClassListItem from './ClassListItem.vue'

const props = defineProps<{
  classes: FilterOption[]
  selectedProgram?: FilterOption
  selectedClass?: FilterOption
}>()

const emit = defineEmits<{
  (e: 'class-select', classOption: FilterOption): void
}>()

const isMobile = useIsMobile()

const handleClassSelect = (classOption: FilterOption) => {
  emit('class-select', classOption)
}
</script>

<template>
  <div class="class-list-section" v-if="props.classes.length > 0">
    <BaseHorizontalList :marginTop="isMobile ? 0 : 16" :gap="12">
      <ClassListItem
        v-for="item in props.classes"
        :key="item.idx"
        :item="item"
        :is-selected="item.idx === props.selectedClass?.idx"
        @click="handleClassSelect(item)"
      />
    </BaseHorizontalList>
  </div>
</template>

<style scoped>
.class-list-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 0px;
}
</style>
